// Generated with util/create-component.js
import ProgressBar from './ProgressBar';

export default ProgressBar;
